import { useNavigate } from "react-router-dom";

import { useLanguage } from "@/i18n/LanguageContext";

type Props = {
  fallbackTo: string;
  label?: string;
};

/** Prefer history when available; otherwise go to a safe fallback route. */
export function BackLink({ fallbackTo, label }: Props) {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const text = label ?? t.common.back;

  return (
    <button
      type="button"
      className="dn-back-link"
      onClick={() => {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate(fallbackTo);
        }
      }}
    >
      ← {text}
    </button>
  );
}
